import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';

import { IMAGE_CONFIG } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { httpLoaderFactory, translationFactory } from '@core-factories';
import {
  apimInterceptor,
  httpErrorInterceptor,
  httpLoaderInterceptor,
} from '@core-interceptors';
import { TranslationService } from '@core-services';
import { environment } from '@environment';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { reducers } from '@store-reducers';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(
      withInterceptors([httpLoaderInterceptor, apimInterceptor, httpErrorInterceptor]),
    ),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      deps: [TranslationService],
      useFactory: translationFactory,
      multi: true,
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        placeholderResolution: 40,
      },
    },
    provideStore(reducers),
    provideEffects([]),
    provideStoreDevtools({
      logOnly: environment.production,
      maxAge: 25,
    }),
  ],
};
